/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expand': {
    width: 24,
    height: 25,
    viewBox: '0 0 24 25',
    data: '<g _fill="#AFAFAF" fill-rule="evenodd"><path pid="0" d="M15.848.869v1.655l5.048-.041-5.627 5.627 1.158 1.159 5.628-5.627-.041 5.048h1.655l.083-7.904zM15.269 16.8l5.628 5.628-5.049-.042v1.655l7.904.042-.083-7.903-1.655.041.041 5.006-5.627-5.627zM.662 8.317l1.655-.041-.041-5.007 5.628 5.628 1.158-1.2-5.627-5.628 5.047.041V.455L.579.414zM2.11 21.227l.042-5.006-1.656-.042-.082 7.904 7.903-.042v-1.655l-5.048.042L8.897 16.8l-1.159-1.2z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/expand.js